import { PieChart, Pie, Sector, ResponsiveContainer, Cell } from "recharts";
import { Card } from "@mui/material";
import { Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useState } from "react";
import "../ProcessLogsPieChart.css";

const COLORS = ["#FF928A", "#8979FF"];
const renderActiveShape = (props: any) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } =
    props;

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    </g>
  );
};

type RunMethodProps = {
  data: any[];
};
const RunMethodProcess = ({ data }: RunMethodProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const onPieEnter = (_: any, index: number) => {
    setActiveIndex(index);
  };

  const total = data.reduce((sum, item) => sum + item.value, 0);
  const enrichedData = data.map((item) => ({
    ...item,
    percent: total ? item.value / total : 0,
  }));
  return (
    <Card
      elevation={1}
      sx={{
        height: "100%",
        minHeight: 270,
        "@media (max-width: 1600px)": {
          minHeight: 260,
        },
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        p: 2,
        borderRadius: 1,
        position: "relative",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{ color: "#9C27B0", alignSelf: "flex-start", mb: 1 }}
      >
        Processes by Run Method
      </Typography>

      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          width: "100%",
          padding: "0 16px",
          "@media (max-width: 1600px)": {
             padding: "0",
          },
        }}
      >
        {data.length === 0 ? (
          <Stack
            sx={{ width: "100%", height: "100%" }}
            alignItems="center"
            justifyContent="center"
            fontSize={13}
            color={"#999"}
          >
            No data to show
          </Stack>
        ) : (
          <ResponsiveContainer width="100%" height={200}>
            <PieChart className="pie-chart-custom">
              <Pie
                activeIndex={activeIndex}
                activeShape={renderActiveShape}
                data={data}
                cx="50%"
                cy="50%"
                // innerRadius={60}
                outerRadius={85}
                fill="#E0E0E0"
                dataKey="value"
                onMouseEnter={onPieEnter}
                labelLine={false}
                stroke="transparent"
              >
                {data.map((_, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        )}
        {/* new ResponsiveContainer for PieChart data viewing */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            mt: 2,
            ml: 1,
          }}
        >
          {enrichedData.map((item, index) => {
            const color = COLORS[index % COLORS.length];
            return (
              <Box
                key={item.name}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  mb: 1,
                }}
              >
                <Typography
                  sx={{
                    color: "#00000099",
                    fontWeight: "500",
                    fontSize: "12px",
                    lineHeight: "16px",
                  }}
                >
                  {item.name}
                </Typography>
                <Box
                  sx={{
                    width: "73px",
                    height: "1px",
                    backgroundColor: color,
                  }}
                />
                <Stack direction="row" gap={1}>
                  <Typography variant="subtitle2" sx={{ color }}>
                    {item.value}
                  </Typography>
                  <Typography variant="subtitle2" sx={{ color }}>
                    {item.percent
                      ? `${(item.percent * 100).toFixed(2)}%`
                      : "0%"}
                  </Typography>
                </Stack>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Card>
  );
};

export default RunMethodProcess;
